import { ButtonElement, ButtonsContainerProps, CcpaButtons, DefaultButtons, TCFButtons } from './interface';
import { VNode } from 'preact';

export const filterButtons = (btn: (VNode<ButtonElement> | undefined)[]): VNode<ButtonElement>[] => {
  return btn.reduce((acc: VNode<ButtonElement>[], el) => {
    if (!el || el.props.disabled) {
      return acc;
    }

    return [...acc, el];
  }, []);
};

export const isCcpaButtons = (buttons: ButtonsContainerProps): buttons is CcpaButtons => {
  return (buttons as CcpaButtons).CcpaButton != null;
};

export const isTCFButtons = (buttons: ButtonsContainerProps): buttons is TCFButtons => {
  return (buttons as TCFButtons).SaveButton != null && (buttons as TCFButtons).AcceptAllButton != null;
};

export const isDefaultButtons = (buttons: ButtonsContainerProps): buttons is DefaultButtons => {
  return (buttons as DefaultButtons).AcceptAllButton != null;
};
